(() => {
  const productHandle = 'darker-navy-blue-boot-cut-jeans';
  const priceBySize = {
    18: 799,
    20: 799,
    22: 799,
    24: 899,
    26: 899,
    28: 899,
    30: 899,
    32: 999,
    34: 999,
    36: 999,
    38: 999,
    40: 999,
  };

  const productInfo = document.querySelector(
    `product-info[data-url^="/products/${productHandle}"]`
  );
  if (!productInfo) return;

  const getSelectedSize = () => {
    const picker = productInfo.querySelector('variant-selects');
    const selectedRadio = picker?.querySelector('input[type="radio"]:checked');
    const selectedDropdown = picker?.querySelector('select[name^="options["]');
    return Number.parseInt(selectedRadio?.value || selectedDropdown?.value, 10);
  };

  const updateDisplayedPrice = () => {
    const price = priceBySize[getSelectedSize()];
    if (!price) return;

    const priceContainer = productInfo.querySelector('[id^="price-"]');
    if (!priceContainer) return;

    const formattedPrice = `Rs. ${price} INR`;
    const priceItems = priceContainer.querySelectorAll(
      '.price__regular .price-item--regular, .price__sale .price-item--last'
    );

    priceItems.forEach((priceItem) => {
      if (priceItem.textContent.trim() !== formattedPrice) {
        priceItem.textContent = formattedPrice;
      }
    });
  };

  productInfo.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      requestAnimationFrame(() => requestAnimationFrame(updateDisplayedPrice));
    }
  });

  const observer = new MutationObserver(updateDisplayedPrice);
  observer.observe(productInfo, { childList: true, subtree: true });
  updateDisplayedPrice();
})();